module.exports = __webpack_public_path__ + "media/img/corporate/team-fr-d01d8e99ba8b6b61f3362468e5d4543b.jpg";